<header class="modal-header cambiar-contra-bg">
  <figure class="modal-title text-center w-100 p-5">
    <img [src]="confirmarRespuesta.imagen" width="100" />
  </figure>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
    <span class="text-white" aria-hidden="true">&times;</span>
  </button>
</header>
<section class="modal-body text-center pl-5 pr-5 pb-5">
  <header class="row text-center">
    <label class="h5 col text-body"><strong>{{confirmarRespuesta.type}}</strong></label>
  </header>
  <footer class="row">
    <p class="text-muted col-12" [innerHTML]="confirmarRespuesta.message"></p>
    <div class="col-12 row d-flex justify-content-center">

      <ng-container *ngIf="confirmarRespuesta.tipoConfirmacionModalType != tipoConfirmacionModalType;else alerta">
        <button class="btn w-25 btn-outline-primary mr-3" (click)="dismiss()">No</button>
        <button class="btn w-25 btn-primary" (click)="confirm()">Si</button>
      </ng-container>
      <ng-template #alerta>
          <button class="btn w-25 btn-primary" (click)="confirm()">{{confirmarRespuesta.buttonTextAlert}}</button>
      </ng-template>
    </div>
  </footer>
</section>
